var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPreIntermediate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 34.928,
    height: 34.928,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_pre_intermediate",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(336.369 222.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179-2",
    "data-name": "Group 179",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21735",
    "data-name": "Path 21735",
    d: "M16.3,32.048A15.753,15.753,0,1,1,32.05,16.294,15.771,15.771,0,0,1,16.3,32.048",
    transform: "translate(1.168 1.17)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21736",
    "data-name": "Path 21736",
    d: "M2.668,18.422A15.739,15.739,0,0,1,28.362,6.217,15.743,15.743,0,1,0,6.214,28.362a15.67,15.67,0,0,1-3.546-9.94",
    transform: "translate(0.868 0.868)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21737",
    "data-name": "Path 21737",
    d: "M16.086,6.532a.86.86,0,0,0-1.066.571,9.643,9.643,0,0,1-9.167,6.8.855.855,0,1,0,0,1.71A11.362,11.362,0,0,0,16.657,7.6a.852.852,0,0,0-.571-1.066",
    transform: "translate(10.76 13.995)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21738",
    "data-name": "Path 21738",
    d: "M17.464,0A17.464,17.464,0,1,0,34.928,17.464,17.484,17.484,0,0,0,17.464,0m0,33.218A15.753,15.753,0,1,1,33.218,17.464,15.771,15.771,0,0,1,17.464,33.218",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21739",
    "data-name": "Path 21739",
    d: "M6.282,3.232A4.186,4.186,0,0,0,2.1,7.415a.855.855,0,1,0,1.71,0,2.47,2.47,0,1,1,4.94,0,.856.856,0,0,0,1.713,0A4.188,4.188,0,0,0,6.282,3.232",
    transform: "translate(4.529 6.964)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21740",
    "data-name": "Path 21740",
    d: "M10.547,3.232a4.186,4.186,0,0,0-4.18,4.183.855.855,0,1,0,1.71,0,2.47,2.47,0,1,1,4.94,0,.856.856,0,0,0,1.713,0,4.188,4.188,0,0,0-4.183-4.183",
    transform: "translate(13.718 6.964)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPreIntermediate);
export default __webpack_public_path__ + "static/media/ic_pre_intermediate.6f80b5f35e162f0395d73ac1f52ae70a.svg";
export { ForwardRef as ReactComponent };